"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("../../../theme/makeStyles");
exports.default = (0, makeStyles_1.makeStyles)(function (theme) { return ({
    labels: {
        display: 'flex',
        alignItems: 'center',
        paddingBottom: '4px'
    },
    selectBoxes: {
        display: 'flex',
        '&:focus-within': {
            '& > $fieldWrapper': {
                '& > :last-child > select': {
                    borderWidth: '2px',
                    borderColor: theme.colors.gray500,
                    padding: ['8px', '32px', '8px', '12px']
                },
                '&:first-of-type > :last-child > select': {
                    paddingLeft: '11px'
                }
            },
            '& > :last-child > select': {
                borderWidth: '2px',
                borderColor: theme.colors.gray500,
                padding: ['8px', '32px', '8px', '12px']
            }
        }
    },
    fieldWrapper: {
        width: '100%',
        '& > :last-child': {
            '&:after': {
                content: "''",
                height: '16px',
                width: '2px',
                position: 'absolute',
                bottom: '16px',
                right: 0,
                background: theme.colors.gray300
            }
        },
        '& > :last-child > select': {
            border: "1px solid ".concat(theme.colors.gray300),
            '&:focus-within': {
                outline: 'none'
            }
        },
        '&:first-of-type': {
            '& > :last-child > select': {
                borderRight: 'none',
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0
            }
        },
        '&:last-of-type': {
            '& > :last-child': {
                '&:after': {
                    content: 'none'
                }
            },
            '& > :last-child > select': {
                borderLeft: 'none',
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0
            }
        },
        '&:not(:first-of-type):not(:last-of-type)': {
            '& > :last-child > select': {
                borderRight: 'none',
                borderLeft: 'none',
                borderRadius: 0
            }
        }
    },
    fieldError: {
        '& > :last-child > select': {
            borderWidth: '2px',
            borderColor: theme.colors.warningAccessible,
            padding: ['8px', '32px', '8px', '12px']
        }
    },
    label: {
        width: '100%'
    }
}); });
